import IconBase, { IconBaseProps } from "./IconBase";

const VideoIconLarge = (props: IconBaseProps) => (
  <IconBase {...props}>
    <g
      transform="translate(-1.2 -1.2) scale(1.12)"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="m8.442 7.788 4.005 1.85a.5.5 0 0 1 0 .908l-4.005 1.85a.5.5 0 0 1-.71-.454V8.242a.5.5 0 0 1 .71-.454z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path
        d="M10 4.167c1.783 0 3.507.238 5.17.716l.462.14a2.498 2.498 0 0 1 1.73 2.14 29.292 29.292 0 0 1 .05 5.099l-.05.575a2.498 2.498 0 0 1-1.734 2.142A18.563 18.563 0 0 1 10 15.833a18.56 18.56 0 0 1-5.17-.716l-.462-.14a2.498 2.498 0 0 1-1.73-2.14 29.292 29.292 0 0 1-.05-5.099l.05-.575a2.498 2.498 0 0 1 1.734-2.142A18.563 18.563 0 0 1 10 4.167z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
  </IconBase>
);

export default VideoIconLarge;
